import script from "./AddressTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddressTable.vue?vue&type=script&lang=ts&setup=true"

import "./AddressTable.vue?vue&type=style&index=0&id=159e5fdd&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-159e5fdd"]])

export default __exports__